<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form" >
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
        </a-form-item>
        <a-form-item label="符号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="[
              'symbol',
              {
                rules: [
                  { required: true, message: '请选择' }
                ],
              },
            ]"
            placeholder="选择"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption">
            <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_value_compare_symbol">{{ val }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="标准值" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number :precision="4" v-decorator="['standard_value', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="标准值"/>
        </a-form-item>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
// import moment from 'moment'
import pick from 'lodash.pick'
import { product_parameter_list, product_parameter_update } from '@/api/trade_product_parameter'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      data: {}
    }
  },
  mounted () {
    product_parameter_list({ id: this.$route.params.id })
      .then(res => {
        console.log(res.data, '我是数据列表@')
        const list = res.data.entries
        if (list && list.length > 0) {
          this.loadEditInfo(list[0])
          this.data = list[0]
        }
      })
  },
  methods: {
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          // eslint-disable-next-line no-console
          console.log('Received values of form: ', values)
          product_parameter_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            })
        }
      })
    },
    loadEditInfo (data) {
      this.$nextTick(() => {
        const { form } = this
        console.log(`将加载 ${this} 信息到表单`)
        new Promise((resolve) => {
          setTimeout(resolve, 10)
        }).then(() => {
          const formData = pick(data, ['id', 'name', 'symbol', 'standard_value'])
          console.log('formData', formData)
          formData.symbol = '' + formData.symbol
          this.id = formData.id
          form.setFieldsValue(formData)
        })
      })
    }
  }
}
</script>
